import script from "./DownloadBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadBox.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadBox.vue?vue&type=style&index=0&id=26c7b188&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c7b188"]])

export default __exports__